import React from "react";
import ArgonTypography from "components/ArgonTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Close as CloseIcon } from "@mui/icons-material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import MeetingDialog from "components/MeetingDialog/MeetingDialog";
import axios, { baseURL } from "utils/api";
import { useParams } from "react-router-dom";

import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import ArgonBox from "components/ArgonBox";
import Table from "examples/Tables/Table";

import Card from "@mui/material/Card";
// Argon Dashboard 2 MUI components
// Argon Dashboard 2 MUI examples
import Footer from "examples/Footer";
import breakpoints from "assets/theme/base/breakpoints";
import { TextField } from "@mui/material";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import { Link } from "react-router-dom";
import tutorTableData from "Views/people/tutor/data/tutorTableData";
import { Box, MenuItem } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Paper from "@mui/material/Paper";

import { useState, useEffect } from "react";

import { Grid } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import PersonIcon from "@mui/icons-material/Person";
import { Chip } from "@mui/material";
import ArgonInput from "components/ArgonInput";
import ArgonButton from "components/ArgonButton";

import { Dialog, DialogContent, DialogTitle, DialogActions } from "@mui/material";
import Dropdown from "components/CustomDropdown/Dropdown";
import ApnaTabs from "components/ApnaTabs/ApnaTabs";

function TutoProfileCard() {
  const { id } = useParams();
  const [fileName, setFileName] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);
  const [meetingDialog, setMeetingDialog] = useState({
    open: false,
    existingMeeting: null,
  });
  const [loadingMeeting, setLoadingMeeting] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);

      // agar image hai to preview show karo
      if (file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewUrl(reader.result);
        };
        reader.readAsDataURL(file);
      } else {
        setPreviewUrl(null);
      }
    }
  };

  const handleDelete = () => {
    setFileName("");
    setPreviewUrl(null);
  };

  const statusOptions = [
    "Adaptable & Reliable",
    "Demanding or Money-Focused",
    "Rigid or Difficult to Manage",
    "Premium Client Ready",
    "Not Suitable for Premium Clients",
    "Inconsistent or Unreliable",
    "Underconfident or Needs Improvement",
    "Inactive or Seeking Classes",
    "Dedicated & Professional",
    "Patient & Empathetic",
  ];

  const [mode, setMode] = useState("");
  const [mode1, setMode1] = useState("");
  const [gender, setgender] = useState("");
  const [level, setLevel] = useState("");
  const [availability, setAvailability] = useState("");
  const [open, setOpen] = useState(false);
  const [statusSelected, setStatusSelected] = useState([]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const toggleStatus = (item) => {
    if (statusSelected.includes(item)) {
      setStatusSelected(statusSelected.filter((i) => i !== item));
    } else {
      setStatusSelected([...statusSelected, item]);
    }
  };

  const handleMeetingClick = async () => {
    try {
      setLoadingMeeting(true);
      // Fetch existing meeting for tutor
      const response = await axios.get(`${baseURL}/meeting?tutorId=${id}`);
      const meetings = response.data?.meetings || [];
      const existingMeeting = meetings.length > 0 ? meetings[0] : null;

      setMeetingDialog({
        open: true,
        existingMeeting,
      });
    } catch (error) {
      console.error("Error fetching meeting:", error);
      // Open dialog anyway for creating new meeting
      setMeetingDialog({
        open: true,
        existingMeeting: null,
      });
    } finally {
      setLoadingMeeting(false);
    }
  };

  const handleCloseMeetingDialog = () => {
    setMeetingDialog({
      open: false,
      existingMeeting: null,
    });
  };

  const handleMeetingSuccess = () => {
    // Optionally refresh data or show success message
    console.log("Meeting submitted successfully");
  };
  return (
    <ArgonBox>
      <Grid container mt={2} spacing={2}>
        {/* Profile Header with Image */}
        <Grid item xs={12}>
          <Card
            sx={{
              borderRadius: 2,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              p: 2,
            }}
          >
            <ArgonBox display="flex" alignItems="center" gap={2}>
              <Avatar
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face"
                alt="John Doe"
                sx={{
                  width: 60,
                  height: 60,
                  border: "2px solid white",
                }}
              />
              <ArgonBox>
                <ArgonTypography variant="h6" fontWeight="medium" color="white">
                  John Doe
                </ArgonTypography>
                <ArgonTypography variant="body2" color="white" fontWeight="medium" opacity={0.9}>
                  Senior Mathematics Teacher
                </ArgonTypography>
                <ArgonBox display="flex" gap={1} mt={0.5}>
                  <Chip
                    label="Active"
                    size="small"
                    fontWeight="medium"
                    sx={{
                      backgroundColor: "rgba(35, 54, 227, 0.67)",
                      color: "#03f40bff",
                      fontSize: "10px",
                    }}
                  />
                  <Chip
                    label="Verified"
                    size="small"
                    sx={{
                      backgroundColor: "rgba(5, 134, 240, 0.67)",
                      color: "white !important",
                      fontSize: "10px",
                    }}
                  />
                </ArgonBox>
              </ArgonBox>
            </ArgonBox>
          </Card>
        </Grid>

        {/* Profile Information */}
        <Grid item xs={12}>
          <Card sx={{ borderRadius: 2, p: 2, boxShadow: 2 }}>
            <ArgonTypography variant="h6" fontWeight="medium" mb={2} color="primary">
              Profile Information
            </ArgonTypography>

            <Grid container spacing={2}>
              {[
                { label: "Full Name", value: "John Doe", icon: "👤" },
                { label: "Badge/Level", value: "Senior Level", icon: "🏆" },
                { label: "Mode", value: "Online", icon: "💻" },
                { label: "Joining Date", value: "Aug 23, 2025", icon: "📅" },
                { label: "Status", value: "Active", icon: "✅" },
                { label: "Salary", value: "₹50,000", icon: "💰" },
              ].map((item, index) => (
                <Grid item xs={6} sm={4} md={3} key={index}>
                  <ArgonBox
                    sx={{
                      p: 1.5,
                      bgcolor: "#f5f7fa",
                      borderRadius: 2,
                      border: "1px solid #e0e7ff",
                    }}
                  >
                    <ArgonBox display="flex" alignItems="center" gap={1} mb={0.5}>
                      <ArgonBox sx={{ fontSize: "0.9rem" }}>{item.icon}</ArgonBox>
                      <ArgonTypography variant="caption" color="text" fontWeight="medium">
                        {item.label}
                      </ArgonTypography>
                    </ArgonBox>
                    <ArgonTypography variant="body2" fontWeight="medium" color="primary">
                      {item.value}
                    </ArgonTypography>
                  </ArgonBox>
                </Grid>
              ))}

              {/* Availability Dropdown */}
              <Grid item xs={6} sm={4} md={3}>
                <ArgonBox
                  sx={{
                    p: 1.5,
                    bgcolor: "#f5f7fa",
                    borderRadius: 2,
                    border: "1px solid #e0e7ff",
                  }}
                >
                  <ArgonBox display="flex" alignItems="center" gap={1} mb={1}>
                    <ArgonBox sx={{ fontSize: "0.9rem" }}>⏰</ArgonBox>
                    <ArgonTypography variant="caption" color="text" fontWeight="medium">
                      Availability
                    </ArgonTypography>
                  </ArgonBox>
                  <Dropdown
                    label=""
                    value={availability}
                    options={["Available", "Not Available", "Busy"]}
                    onChange={(e) => setAvailability(e.target.value)}
                  />
                </ArgonBox>
              </Grid>
            </Grid>

            {/* Action Buttons */}
            <Box display="flex" gap={1} justifyContent="center" mt={2}>
              <ArgonButton
                onClick={handleMeetingClick}
                variant="contained"
                color="info"
                size="medium"
                disabled={loadingMeeting}
                startIcon={<VideoCallIcon />}
              >
                {meetingDialog.existingMeeting ? "Edit Meeting" : "Submit Meeting"}
              </ArgonButton>
              <ArgonButton
                onClick={handleOpen}
                variant="contained"
                startIcon={<PersonIcon />}
                color="primary"
                size="medium"
              >
                Edit Profile
              </ArgonButton>
              <ArgonButton
                variant="outlined"
                color="primary"
                size="medium"
                startIcon={<EditIcon />}
              >
                Submit Evaluation
              </ArgonButton>
            </Box>
          </Card>
        </Grid>
      </Grid>
      {open && (
        <ArgonBox
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <ArgonBox
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "20px",
              width: "90%",
              maxWidth: 900,
              maxHeight: "95vh",
              overflowY: "auto",
              boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            {/* Header */}
            <ArgonBox
              sx={{
                background: "rgba(255,255,255,0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "20px 20px 0 0",
                p: 3,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <ArgonBox
                    sx={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      p: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <EditIcon sx={{ color: "white", fontSize: "24px" }} />
                  </ArgonBox>
                  <ArgonBox>
                    <ArgonTypography variant="h5" fontWeight="medium" color="white">
                      Edit Profile
                    </ArgonTypography>
                    <ArgonTypography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                      Update your profile information
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                <ArgonButton
                  variant="text"
                  onClick={handleClose}
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    "&:hover": {
                      background: "rgba(255,255,255,0.2)",
                    },
                  }}
                >
                  ×
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>

            {/* Form Content */}
            <ArgonBox sx={{ background: "white", borderRadius: "0 0 20px 20px", p: 4 }}>
              <form>
                {/* Personal Information Section */}
                <ArgonBox mb={4}>
                  <ArgonBox display="flex" alignItems="center" gap={1.5} mb={3}>
                    <PersonIcon sx={{ color: "#667eea", fontSize: "20px" }} />
                    <ArgonTypography variant="h6" fontWeight="medium" color="#2c3e50">
                      Personal Information
                    </ArgonTypography>
                  </ArgonBox>

                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <ArgonBox>
                        <ArgonTypography variant="body2" fontWeight="medium" color="#2c3e50" mb={1}>
                          First Name
                        </ArgonTypography>
                        <ArgonInput placeholder="Enter First Name" size="medium" fullWidth />
                      </ArgonBox>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ArgonBox>
                        <ArgonTypography variant="body2" fontWeight="medium" color="#2c3e50" mb={1}>
                          Last Name
                        </ArgonTypography>
                        <ArgonInput placeholder="Enter Last Name" fullWidth size="medium" />
                      </ArgonBox>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ArgonBox>
                        <ArgonTypography variant="body2" fontWeight="medium" color="#2c3e50" mb={1}>
                          Email Address
                        </ArgonTypography>
                        <ArgonInput placeholder="Enter Email" fullWidth size="medium" />
                      </ArgonBox>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ArgonBox>
                        <ArgonTypography variant="body2" fontWeight="medium" color="#2c3e50" mb={1}>
                          Subject
                        </ArgonTypography>
                        <ArgonInput placeholder="Enter Subject" fullWidth size="medium" />
                      </ArgonBox>
                    </Grid>
                  </Grid>
                </ArgonBox>

                {/* Professional Information Section */}
                <ArgonBox mb={4}>
                  <ArgonBox display="flex" alignItems="center" gap={1.5} mb={3}>
                    {/* <WorkIcon sx={{ color: "#4ECDC4", fontSize: "20px" }} /> */}
                    <ArgonTypography variant="h6" fontWeight="medium" color="#2c3e50">
                      Professional Details
                    </ArgonTypography>
                  </ArgonBox>

                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <ArgonBox>
                        <ArgonTypography variant="body2" fontWeight="medium" color="#2c3e50" mb={1}>
                          Salary
                        </ArgonTypography>
                        <ArgonInput placeholder="Enter Salary" size="medium" fullWidth />
                      </ArgonBox>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ArgonBox>
                        <ArgonTypography variant="body2" fontWeight="medium" color="#2c3e50" mb={1}>
                          Mode Of Tuition
                        </ArgonTypography>
                        <Dropdown
                          value={mode1}
                          options={["Online", "Offline", "Hybrid"]}
                          onChange={(e) => setMode1(e.target.value)}
                        />
                      </ArgonBox>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ArgonBox>
                        <ArgonTypography variant="body2" fontWeight="medium" color="#2c3e50" mb={1}>
                          Level/Badge
                        </ArgonTypography>
                        <Dropdown
                          value={level}
                          options={["🥉 Level 1", "🥈 Level 2", "🥇 Level 3", "💎 Level 4"]}
                          onChange={(e) => setLevel(e.target.value)}
                        />
                      </ArgonBox>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ArgonBox>
                        <ArgonTypography variant="body2" fontWeight="medium" color="#2c3e50" mb={1}>
                          English Fluency (0-10)
                        </ArgonTypography>
                        <ArgonInput
                          type="range"
                          min={0}
                          max={10}
                          sx={{
                            '& input[type="range"]': {
                              background: "linear-gradient(45deg, #667eea, #764ba2)",
                              borderRadius: "10px",
                            },
                          }}
                        />
                      </ArgonBox>
                    </Grid>
                  </Grid>
                </ArgonBox>

                {/* Status Selection */}
                <ArgonBox mb={4}>
                  <ArgonBox display="flex" alignItems="center" gap={1.5} mb={3}>
                    {/* <FlagIcon sx={{ color: "#FF9800", fontSize: "20px" }} /> */}
                    <ArgonTypography variant="h6" fontWeight="medium" color="#2c3e50">
                      Status Selection
                    </ArgonTypography>
                  </ArgonBox>

                  <ArgonBox
                    sx={{
                      background: "#f8f9fa",
                      border: "2px dashed #dee2e6",
                      borderRadius: "12px",
                      p: 3,
                      maxHeight: 200,
                      overflowY: "auto",
                    }}
                  >
                    <Grid container spacing={2}>
                      {statusOptions.map((item, idx) => (
                        <Grid item xs={6} sm={4} md={3} key={idx}>
                          <ArgonBox
                            sx={{
                              p: 2,
                              borderRadius: "8px",
                              cursor: "pointer",
                              background: statusSelected.includes(item)
                                ? "linear-gradient(45deg, #4CAF50, #45a049)"
                                : "white",
                              color: statusSelected.includes(item) ? "white" : "#2c3e50",
                              border: statusSelected.includes(item)
                                ? "2px solid #4CAF50"
                                : "2px solid #e0e0e0",
                              textAlign: "center",
                              fontWeight: "600",
                              fontSize: "15px",
                              transition: "all 0.3s ease",
                              "&:hover": {
                                transform: "translateY(-2px)",
                                boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                              },
                            }}
                            onClick={() => toggleStatus(item)}
                          >
                            {item}
                          </ArgonBox>
                        </Grid>
                      ))}
                    </Grid>

                    {statusSelected.length > 0 && (
                      <ArgonBox mt={2}>
                        <ArgonTypography variant="body2" fontWeight="medium" color="#2c3e50" mb={1}>
                          Selected Status:
                        </ArgonTypography>
                        <ArgonBox display="flex" gap={1} flexWrap="wrap">
                          {statusSelected.map((s, i) => (
                            <Chip
                              key={i}
                              label={s}
                              size="small"
                              sx={{
                                bgcolor: "#e8f5e8",
                                color: "#2e7d32",
                                fontWeight: "600",
                              }}
                            />
                          ))}
                        </ArgonBox>
                      </ArgonBox>
                    )}
                  </ArgonBox>
                </ArgonBox>

                {/* Action Buttons */}
                <ArgonBox display="flex" justifyContent="flex-end" gap={2}>
                  <ArgonButton
                    variant="outlined"
                    onClick={handleClose}
                    sx={{
                      borderColor: "#6c757d",
                      color: "#6c757d",
                      borderRadius: "10px",
                      px: 4,
                      py: 1.2,
                      "&:hover": {
                        borderColor: "#495057",
                        backgroundColor: "#f8f9fa",
                      },
                    }}
                  >
                    Cancel
                  </ArgonButton>
                  <ArgonButton
                    variant="contained"
                    type="submit"
                    color="primary"
                    sx={{
                      borderRadius: "10px",
                      px: 4,
                      py: 1.2,
                      boxShadow: "0 8px 25px rgba(102, 126, 234, 0.3)",
                      "&:hover": {
                        boxShadow: "0 12px 35px rgba(102, 126, 234, 0.4)",
                        transform: "translateY(-2px)",
                      },
                      transition: "all 0.3s ease",
                    }}
                  >
                    Save Changes
                  </ArgonButton>
                </ArgonBox>
              </form>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}

      {/* Meeting Dialog */}
      <MeetingDialog
        open={meetingDialog.open}
        onClose={handleCloseMeetingDialog}
        tutorId={id}
        existingMeeting={meetingDialog.existingMeeting}
        onSuccess={handleMeetingSuccess}
      />
    </ArgonBox>
  );
}

export default TutoProfileCard;
